"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchFoldersFromSearch = exports.fetchFilesFromSearch = exports.BASE_URI = void 0;

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _pick = _interopRequireDefault(require("../utils/pick"));

var _Constants = require("../Constants");

var _Api = require("../constants/Api");

var BASE_URI = 'file-manager-search/v2/search';
exports.BASE_URI = BASE_URI;
var DEFAULT_QUERY = {
  category: _Constants.ObjectCategory.FILE
};

var translateLegacyOptions = function translateLegacyOptions(legacyOptions) {
  var options = (0, _pick.default)(legacyOptions, ['archived', 'limit', 'offset']);

  if (legacyOptions.type) {
    options.fileType = legacyOptions.type;
  }

  if (legacyOptions.search) {
    options.name = legacyOptions.search;
    options.searchType = 'contains';
    options.mimicContains = true;
  } else {
    if (legacyOptions.folder_id) {
      options.folderId = legacyOptions.folder_id;

      if (options.folderId === 'None') {
        options.folderId = 0;
      }
    }
  }

  if (legacyOptions.order_by) {
    options.orderBy = legacyOptions.order_by.replace('updated', 'updatedAt');
  }

  return options;
};

var fetchFilesFromSearch = function fetchFilesFromSearch(legacyOptions) {
  var options = translateLegacyOptions(legacyOptions);
  var query = Object.assign({}, DEFAULT_QUERY, {}, options);
  return _apiClient.default.get(BASE_URI, {
    query: query
  });
};

exports.fetchFilesFromSearch = fetchFilesFromSearch;

var fetchFoldersFromSearch = function fetchFoldersFromSearch(legacyOptions) {
  var options = translateLegacyOptions(legacyOptions);
  var query = Object.assign({}, DEFAULT_QUERY, {}, options, {
    category: _Constants.ObjectCategory.FOLDER,
    limit: _Api.FOLDER_SEARCH_REQUEST_LIMIT
  });
  return _apiClient.default.get(BASE_URI, {
    query: query
  });
};

exports.fetchFoldersFromSearch = fetchFoldersFromSearch;